import React, { useEffect, useState } from 'react'
import {  StyledModalWorkout,StyledBodyWellness, HeaderText, Divider, DisableEnableButton, WellnessCategrydCard, CategoryCard, CardContent  } from './styles'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { CloseIconBranding, dropWellnessIcon } from '../../utils/icons'
import { AddupdatePersonalizeWellnessCatgory, GetWellnessHubCategories } from '../../redux/constants/apiConstants'
import { fetchApi } from '../../utils/methods'
import { toast } from 'react-toastify'
import { ImageUrl } from '../../utils/constants'
import { showSuccessToast } from './ToastHelper'



function PersonalizeWellnessPopup({closePopup,showWellnessPopup,FetchWellnessHubCategories }) {

  const [wellnessCategory, setWellnessCategory] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedInterests, setSelectedInterests] = useState([]);
  //   const [interestData, /*steInterestData*/]= useState(true);


  useEffect(()=>{
    FetchWellnessHubCategory();
  },[]);
  
   
  const SuccessToast = (text,message) => {
    showSuccessToast(text,message);
  }


  const savePersonalizeWellnessData = async () => {
    try {
      const payload = {
        article: selectedInterests
          .filter((item) => item.type === "articles")
          .map((item) => item.id),
        fitness_video: selectedInterests
          .filter((item) => item.type === "fitness")
          .map((item) => item.id),
        recipe: selectedInterests
          .filter((item) => item.type === "recipes")
          .map((item) => item.id),
      }; 
      const res = await fetchApi(AddupdatePersonalizeWellnessCatgory, "POST",payload);
      if (res.status === "success") {
        // toast.success(res.message);
        SuccessToast("Data Saved" ,res.message);
        FetchWellnessHubCategories();
        closePopup();
      }
      else{
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };


  const FetchWellnessHubCategory = async()=>{
    try {
      const res = await fetchApi(GetWellnessHubCategories, "GET");
      if(res.status === 'success'){
        // setWellnessCategory(res.data)
        setWellnessCategory({
          articles: res.data.article_categories || [],
          fitness: res.data.fitness_video_categories || [],
          recipes: res.data.recipe_categories || []
        });
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }



  const WellnessData = [
    "Education",
    "Wellness & Fitness Videos",
    "Nutrition Recipes",
  ];

  const handleDropDown = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const SelectProduct = (selectedId,type) => {
    setSelectedInterests((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === selectedId && item.type === type);
  
      if (isAlreadySelected) {
        // return prevSelected.filter((item) => item.id !== selectedId &&  item.type === type);
        return prevSelected.filter((item) => !(item.id === selectedId && item.type === type));

      } 

      const categoryCount = prevSelected.filter((i) => i.type === type).length;
      if (categoryCount >= 4) {
        toast.error("You can select a maximum of 4 options in this category");
        return prevSelected; // block adding new item
      }
  
      // Add item if not selected & within limit
      const allInterest = [
        ...wellnessCategory.articles,
        ...wellnessCategory.fitness,
        ...wellnessCategory.recipes,
      ];

      // const allInterest = [
      //   ...wellnessCategory.articles,
      //   ...wellnessCategory.fitness,
      //   ...wellnessCategory.recipes

      // ]
      // Find the interest object from wellnessInterests by id
      const interestToAdd = allInterest.find((item) => item.id === selectedId);
      if (interestToAdd) {
        return [...prevSelected, {...interestToAdd,type}];
      }
      return prevSelected; // Fallback if not found
    
    });
  };


  const articleCount = selectedInterests.filter((i) => i.type === "articles").length;
  const fitnessCount = selectedInterests.filter((i) => i.type === "fitness").length;
  const recipeCount = selectedInterests.filter((i) => i.type === "recipes").length;


  // const isDisabled = !(
  //   articleCount >= 2 &&
  //   fitnessCount >= 2 &&
  //   recipeCount >= 2
  // );

  
  
  const isDisabled = !(
    articleCount >= 2 && articleCount <= 4 &&
    fitnessCount >= 2 && fitnessCount <= 4 &&
    recipeCount  >= 2 && recipeCount  <= 4
  );

  return (
    
    <StyledModalWorkout show={showWellnessPopup} newWidth={"800px"}  isPadding={"20px !important"}>
    
      <Modal.Header closeButton onHide={closePopup} style={{ background: "white" }}>
        <HeaderText>
          <div className="subContainer">
            <div className="popupHeading" >Personalize My Hub</div>
            <div className="closeIcon" onClick={()=>closePopup()}>{CloseIconBranding("#DA6C74",16,16)}</div>
          </div>
        </HeaderText>
      </Modal.Header>
      <Divider isWidth={"93%"} isOpacity={"40%"} isMargin={"0px 20px"}></Divider>
  
      <StyledBodyWellness isPadding={"16px !important"}>
        <div className="message">Choose 2-4 options in each of the 3 wellness categories below.</div>


        <WellnessCategrydCard>
          {/* <Divider id="divider" isMargin={"20px 0px"}></Divider> */}
          {WellnessData?.map((data,index)=>(
            <CategoryCard key={index} >
              <div className="interest-container" onClick={()=>handleDropDown(index)}>
                <div className="interestType">{data}</div>
                <div  style={{   transform: activeIndex === index ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"}} className="dropicon"> {dropWellnessIcon()}</div>
              </div>
              {activeIndex === index && (



                <div className="dropdown-wrapper">
                  {/* Article Categories */}
                  {data === "Education" &&
                       wellnessCategory.articles?.map((item, i) => (
                         <CardContent 
                           userInterest={selectedInterests.some((s) => s.id === item.id && s.type === "articles")} key={i} onClick={() => SelectProduct(item.id,"articles")}>
                           <img src={`${ImageUrl}/${item.image}`}  className="category-img" />
                           <div className="listContent">{item.category_name}</div>
                         </CardContent>))
                  }
                  
                  {/* Fitness Categories */}
                  {data === "Wellness & Fitness Videos" &&
                       wellnessCategory.fitness?.map((item, i) => (
                         <CardContent key={i} onClick={() => SelectProduct(item.id,"fitness")}  userInterest={selectedInterests.some((s) => s.id === item.id && s.type === "fitness")}>
                           <img src={`${ImageUrl}/${item.image}`}  className="category-img"  />
                           <div className="listContent">{item.category_name}</div>
                         </CardContent> ))
                  }
                  {/* Recipe Categories */}
                  {data === "Nutrition Recipes" &&
                       wellnessCategory.recipes?.map((item, i) => (
                         <CardContent key={i} onClick={() => SelectProduct(item.id,"recipes")}  userInterest={selectedInterests.some((s) => s.id === item.id && s.type === "recipes")}>
                           <img src={`${ImageUrl}/${item.image}`}  className="category-img"  />
                           <div className="listContent">{item.category_name}</div>
                         </CardContent>
                       ))}
                </div>  )}


              {/* <div className="dropdown-wrapper">
                   {wellnessCategory.map((listData, index) => {
                    const isMatchingInterest = selectedInterests?.some((item) => item?.id === listData?.id); // Check if listData?.id exists in interest array
                    if (data.toLowerCase().trim() === (interestData ? listData?.interest_type.toLowerCase().trim() : listData?.goal_type.toLowerCase().trim())) {
                      return (
                        <DropdownContent userInterest={isMatchingInterest} key={index} onClick={()=>SelectProduct(listData?.id)} style={{cursor:'pointer'}}>
                          {interestData && isMatchingInterest  ?  <img src={`${ImageUrl}/${listData?.interest_white_icon}`} /> :  <img src={`${ImageUrl}/${listData?.interest_color_icon}`} />}
                          <div className="listContent">{(listData?.name)}</div>
                        </DropdownContent>
                      );
                    }
                  })}
                </div> */}
            </CategoryCard>))}
        </WellnessCategrydCard>
      </StyledBodyWellness>



      <Modal.Footer>
        <DisableEnableButton
          isCursor={!isDisabled} 
          active={!isDisabled}
          disabledColor={isDisabled ? "#989898" : "#FEFEFE"}
          disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"}
          //   margin={"20px 0 0 0"}
          onClick={() => !isDisabled && savePersonalizeWellnessData()}
        >
          Personalize My Dashboard
        </DisableEnableButton>
      </Modal.Footer>

      
      
    </StyledModalWorkout>
  )
}




PersonalizeWellnessPopup.propTypes ={
  closePopup: PropTypes.func.isRequired,
  openPopup: PropTypes.bool.isRequired,
  showWellnessPopup: PropTypes.bool.isRequired,
  FetchWellnessHubCategories: PropTypes.func.isRequired,
}

export default PersonalizeWellnessPopup;
